export function checkIsDirty<T extends object>(criteria: T): boolean {

  const excludeKeys = ['pageSize', 'pageNumber', 'orderBy', 'descOrder']
  return Object.entries(criteria)
    .filter(([key]) => !excludeKeys.includes(key)  )
    .some(([_, value]) => {
      if (value === null || value === undefined) return false;
      if (typeof value === 'string' && value.trim() === '') return false;
      return true;
    });
}